// extracted by mini-css-extract-plugin
module.exports = {"duleImage":"dule-image-module--dule-image--35WI6","duleImage__image":"dule-image-module--dule-image__image--MrufE"};